// src/routes/artRoutes.jsx
import ArtPage from "../pages/ArtPage";
import Design24About from "../pages/ArtPages/Design24About";
import ProgramDetailPage from "../pages/ArtPages/ProgramDetailPage";
import NewsDetailPage from "../pages/ArtPages/NewsDetailPage";

const artRoutes = [
  { path: "/art", element: <ArtPage /> },
  { path: "/art/about", element: <Design24About /> },
  { path: "/art/programs/:slug", element: <ProgramDetailPage /> },
  { path: "/art/news/:slug", element: <NewsDetailPage /> },
  // Thêm route con khác nếu cần
];

export default artRoutes;
